module.exports = __webpack_public_path__ + "media/images/person-woman-apple-hotel-bb94ced17eea1afac2c32c526dd4650c.jpg";